module.exports = __webpack_public_path__ + "static/media/tpn-events-on-demand.c6123c42.jpg";